


























































































































































































































































import Vue from 'vue';
import {
  Component, Inject, Watch, Emit, Prop,
} from 'vue-property-decorator';
import { KFiSelector } from '@kasasa/fbase-components';
import moment from 'moment';

import LocalDateTime from '@/types/localdatetime';
import TextBoxDatePicker from '@/components/textboxdatepicker.vue';
import RecompDialog from '@/components/recomp-dialog.vue';
import { ReloadPoint, reloadPoints } from '@/types/reloadpoints';
import { Cycle } from '@/types/cycle';
import { reloadReasons } from '@/api/reload/reloadreasons';
import UserResource from '@/api/user/UserResource';
import ReloadResource from '@/api/reload/ReloadResource';
import { ReloadDataTableEntry } from '@/api/reload/ReloadDataTableEntry';
import ConfigResource from '@/api/config/ConfigResource';
import { ReloadRequest } from '@/api/reload/ReloadRequest';
import RecompArguments, { RecompArgument } from '@/api/reload/RecompArgument';

@Component({
  components: {
    'fi-selector': KFiSelector,
    'text-box-date-picker': TextBoxDatePicker,
    'recomp-dialog': RecompDialog,
  },
})
export default class ReloadJobDialog extends Vue {
	@Inject('UserResource')
	private userResource!: UserResource;

	@Inject('ConfigResource')
	private configResource!: ConfigResource;

	@Inject('ReloadResource')
	private reloadResource!: ReloadResource;

	@Prop() reloadJobToClone!: ReloadDataTableEntry;

	GENERIC_RELOAD_ERROR: string =
		'An unexpected error occurred while attempting to initiate reload.';

	dialog: boolean = false;

	submittingJob: boolean = false;

	validatingDate: boolean = false;

	reloadErrorMessage: string = '';

	largeReloadConfirmed = false;

	startDateValid = false;

	resetRecompDialog:number = 0;

	// recomp variables
	enableRecompOptions = false;

	reloadStartingOnQualStart = true;

	userConfirmedRecompStartingOnNonQualStart = false;

	reloadIncludesRecomp = false;

	recompArgumentList: Array<RecompArgument> = [];

	jobExecutionDescriptionMap: Map<number, string> = new Map< number, string>();
	// end of recomp variables

	showLargeReloadConfirmation = false;

	dateValidationError: string = '';

	points: Array<ReloadPoint> = reloadPoints;

	allFiCycles: Array<Cycle> = [];

	reloadCycles: Array<Cycle> = [];

	reasons: Map<String, String> = reloadReasons;

	oneDay: number = 1000 * 60 * 60 * 24;

	yesterday: Date = new Date(new Date().getTime() - this.oneDay);

	yesterdayString: string = this.yesterday.toISOString().substr(0, 10);

	// reload properties
	reloadPoint: string = '';

	selectedFi: any = {};

	startDateString: string = '';

	startDateFriendlyString: string = '';

	endDateString: string = this.yesterdayString;

	endDateFriendlyString: string = this.yesterday.toLocaleDateString();

	totalReloadDays: number = 0;

	cancelExistingReloads: boolean = true;

	skipRewardsProcessing: boolean = false;

	reloadReason: any = [];
	// end of reload properties

	allowEndDate: boolean = false;

	shouldReloadSummaryShow() {
	  return this.hasSelectedFi()
                        && this.reloadPoint
                        && this.startDateValid
                        && this.reloadReason.length > 0
						&& (!this.reloadIncludesRecomp || this.reloadCycles.length === this.recompArgumentList.length);
	}

	shouldShowReloadNotStartsOnQualStartForCycleWarningDialog() {
	  return this.reloadIncludesRecomp
		  && !this.reloadStartingOnQualStart
		  && !this.userConfirmedRecompStartingOnNonQualStart;
	}

	@Watch('selectedFi')
	onFiChanged() {
	  if (this.selectedFi) {
	    this.reloadErrorMessage = '';
	    if (this.startDateFriendlyString !== '') {
	      this.validateStartDate();
	    }
	    this.loadAllFiCycles();
	  }
	}

	@Watch('reloadJobToClone')
	cloneJob() {
	  if (this.reloadJobToClone.id) {
	    const startDate = new LocalDateTime(this.reloadJobToClone.startDate);
	    this.startDateString = moment(startDate.toISODateString()).format('YYYY-MM-DD');
	    this.startDateFriendlyString = startDate.toFriendlyDateString();
	    const endDate = new LocalDateTime(this.reloadJobToClone.endDate);
	    this.endDateString = moment(endDate.toISODateString()).format('YYYY-MM-DD');
	    this.endDateFriendlyString = endDate.toFriendlyDateString();

	    if (this.getSelectedFiId() === this.reloadJobToClone.fiId) {
	      // if the fi is the same, we have to manually invoke onFiChanged() manually
	      this.onFiChanged();
	    } else {
	      this.selectedFi = this.reloadJobToClone.fiId;
	    }
	    this.totalReloadDays = this.getTotalReloadDays();
	    this.reloadStartDateAdjust(false);
	    this.dialog = true;
	  }
	}

	shouldRunJobButtonBeDisabled() {
	  return !this.hasSelectedFi()
	  || this.reloadPoint === undefined
	  || !this.startDateValid
	  || this.reloadReason.length === 0
	  || (this.reloadIncludesRecomp && this.reloadCycles.length !== this.recompArgumentList.length);
	}

	onJobExecutionSelectedForCycle(
	  cycleId: number,
	  jobExecutionId: number,
	  description: string,
	) {
	  const foundRecompArgument = this.recompArgumentList.filter(
	    (x: RecompArgument) => x.cycleId === cycleId,
	  );
	  if (foundRecompArgument.length > 0) {
	    // should only be 1 found
	    foundRecompArgument[0].jobExecutionId = jobExecutionId;
	  } else {
	    this.recompArgumentList.push({
	      cycleId,
	      jobExecutionId,
	    });
	  }
	  this.jobExecutionDescriptionMap.set(jobExecutionId, description);
	  // Need to force an update so the summary screen has the
	  // correct cycle summary text.
	  this.$forceUpdate();
	}

	getCycleSummary(cycleId: number): string {
	  // should only be 1 returned by filter
	  const cycleForId = this.allFiCycles.filter(
	    (cycle: Cycle) => cycle.id === cycleId,
	  )[0];
	  if (cycleForId) {
	  	return `${cycleForId.qualificationStartDate} to ${cycleForId.qualificationEndDate}`;
	  }
	  // This is only returned if the summary is attempting to show before the fi cycles are loaded,
	  // which should only happen for a split second during job double-click clone scenarios.
	  // A refresh when the cycles are loaded should refresh the summary with the correct text.
	  return '';
	}

	getRecompDescription(recompArg: RecompArgument): string {
	  return `Cycle: ${this.getCycleSummary(recompArg.cycleId)} - Job Execution recomp: ${
		  this.jobExecutionDescriptionMap.get(recompArg.jobExecutionId)}`;
	}

	@Watch('dialog')
	onDialogToggle() {
	  // Reset on closing the dialog
	  if (!this.dialog) {
	    this.submittingJob = false;
	    this.validatingDate = false;
	    this.reloadErrorMessage = '';
	    this.largeReloadConfirmed = false;
	    this.startDateValid = false;
	    this.allowEndDate = false;
	    this.showLargeReloadConfirmation = false;
	    this.reloadPoint = '';
	    // this.selectedFi = undefined;
	    this.startDateString = '';
	    this.startDateFriendlyString = '';
	    this.endDateString = this.yesterdayString;
	    this.endDateFriendlyString = this.yesterday.toLocaleDateString();
	    this.totalReloadDays = 0;
	    this.reloadReason = [];
	    this.cancelExistingReloads = true;
	    this.skipRewardsProcessing = false;
	    for (let i: number = 0; i < this.points.length; i++) {
	      this.points[i].selected = false;
	    }
	    this.jobExecutionDescriptionMap.clear();
	    this.reloadCycles = [];
	    this.recompArgumentList = [];
	    this.enableRecompOptions = false;
	    this.$emit('reloadDialogClosed');
	  }
	}

	@Emit('includeRecompChecked')
	onRecompCheckbox(checked: boolean) {
	  if (checked) {
	    this.reloadIncludesRecomp = true;
	    if (
	      moment(this.startDateString).isAfter(this.reloadCycles[0].qualificationStartDate)
	    ) {
	      this.reloadStartingOnQualStart = false;
	    }
	  } else {
	    this.reloadIncludesRecomp = false;
	    this.userConfirmedRecompStartingOnNonQualStart = false;
	  }
	}

	reloadStartDateAdjust(adjustStartDate: boolean) {
	  if (adjustStartDate) {
	    this.startDateString = this.reloadCycles[0].qualificationStartDate;
	    this.reloadStartingOnQualStart = true;
	  }
	  this.userConfirmedRecompStartingOnNonQualStart = true;
	}

	loadAllFiCycles() {
	  this.allFiCycles = [];
	  this.reloadCycles = [];
	  this.configResource
	    .getAllCycles(this.getSelectedFiId())
	    .then((returnedCycles: Cycle[]) => {
	      // sort cycles by qual start date
		  this.allFiCycles = returnedCycles.sort((a, b) => ReloadJobDialog.compareCyclesForSort(a, b));
		  if (this.reloadJobToClone) {
			 this.loadReloadCycles();
		  }
	    })
	    .catch((error: any) => {
	      console.log(error);
	    });
	}

	getSelectedFiId() {
	  if (this.selectedFi) {
	    if (typeof this.selectedFi === 'number') {
	      return this.selectedFi;
	    }
	      if (this.selectedFi.fiId) {
	        return this.selectedFi.fiId;
	      }
	  }
	  return undefined;
	}

	static compareCyclesForSort(a: Cycle, b: Cycle): number {
	  return a.qualificationStartDate < b.qualificationStartDate ? -1 : 1;
	}

	setReloadPoint(selectedReloadPointId: string) {
	  const index = this.points.findIndex(reloadPoint => reloadPoint.id === selectedReloadPointId);
	  if (this.selectedFi && selectedReloadPointId) {
	    this.reloadPoint = this.points[index].id;

	    for (let i = 0; i < index; i++) {
	      this.points[i].selected = false;
	    }

	    for (let i = index; i < this.points.length; i++) {
	      this.points[i].selected = true;
	    }
	  }
	}

	static getISODateString(fields: number[]) {
	  return new LocalDateTime(fields).toISODateString();
	}

	public onNewStartDate(date: string) {
	  this.startDateString = date;
	  const localDate: LocalDateTime = new LocalDateTime(date);
	  this.startDateFriendlyString = localDate.toFriendlyDateString();
	  this.totalReloadDays = this.getTotalReloadDays();
	  this.largeReloadConfirmed = false;
	  this.validateStartDate();
	  this.loadReloadCycles();
	}

	public onNewEndDate(date: string) {
	  this.endDateString = date;
	  const localDate: LocalDateTime = new LocalDateTime(date);
	  this.endDateFriendlyString = localDate.toFriendlyDateString();
	  this.totalReloadDays = this.getTotalReloadDays();
	  this.largeReloadConfirmed = false;
	  this.validateStartDate();
	  this.loadReloadCycles();
	}

	validateStartDate() {
	  this.validatingDate = true;
	  this.startDateValid = false;
	  this.dateValidationError = '';

	  if (this.selectedFi) {
	    this.configResource
	      .getIsProcessingDay(this.getSelectedFiId(), this.startDateString)
	      .then((result: any) => {
	        this.validatingDate = false;
	        this.startDateValid = result;
	        this.reloadErrorMessage = '';
	        if (!this.startDateValid) {
	          this.dateValidationError =							`${this.startDateFriendlyString}`
							+ ' is a non-processing day. Please select another date.';
	        }
	      })
	      .catch((error: any) => {
	        if (error.response.status !== 401) {
	          this.validatingDate = false;
	          if (error.response.status === 404) {
	            this.dateValidationError =								'No processing dates have been configured for this FI.';
	          } else {
	            this.reloadErrorMessage =								'An unexpected error occurred while'
								+ ' attempting to validate reload start date.';
	            this.startDateString = new LocalDateTime().toISODateString();
	            this.startDateFriendlyString = '';
	          }
	        }
	      });
	  }
	}

	getTotalReloadDays() {
	  const startDate: Date = new LocalDateTime(this.startDateString).toDate();
	  const endDate: Date = new LocalDateTime(this.endDateString).toDate();
	  return Math.ceil((endDate.getTime() - startDate.getTime()) / this.oneDay);
	}

	hasSelectedFi() {
	  const currentlySelectedFi = this.getSelectedFiId();
	  return this.getSelectedFiId() !== undefined;
	}

	loadReloadCycles() {
	  const tempReloadCycles: Cycle[] = [];
	  this.allFiCycles.forEach((currentCycle: Cycle) => {
	    if (
	      this.isFirstCycleInReload(currentCycle)
				|| this.isCycleEntirelyInReloadPeriod(currentCycle)
	    ) {
	      tempReloadCycles.push(currentCycle);
	    }
	  });
	  this.reloadCycles = tempReloadCycles;
	  this.enableRecompOptions = false;
	  this.reloadCycles.forEach((currentCycle: Cycle) => {
	    if (
	      moment(this.startDateString).isSameOrBefore(
	        currentCycle.qualificationEndDate,
	      )
				&& moment(this.endDateString).isSameOrAfter(
				  currentCycle.qualificationEndDate,
				)
	    ) {
	      this.enableRecompOptions = true;
	    }
	  });
	  if (this.reloadJobToClone && this.reloadJobToClone.id) {
	    // set the rest of the data
	    this.setReloadPoint(this.reloadJobToClone.reloadPoint);

	    if (this.reloadJobToClone.includesRecomp) {
	      this.enableRecompOptions = true;
	      this.reloadIncludesRecomp = true;
	    }

	    this.recompArgumentList = this.reloadJobToClone.recompArgumentList;
	    this.reloadReason = [this.reloadJobToClone.reason, this.reasons.get(this.reloadJobToClone.reason)];
	    this.cancelExistingReloads = this.reloadJobToClone.cancelExistingReloads;
	    this.skipRewardsProcessing = this.reloadJobToClone.skipRewardsProcessing;
	  }
	}

	isFirstCycleInReload(cycle: Cycle): boolean {
	  return (
	    this.reloadStartDateOnOrBeforeQualEndDate(cycle)
			&& this.reloadStartDateOnOrAfterQualStartDate(cycle)
	  );
	}

	isPastReloadPeriod(cycle: Cycle): boolean {
	  return moment(cycle.qualificationStartDate).isAfter(this.startDateString);
	}

	reloadStartDateOnOrBeforeQualEndDate(cycle: Cycle): boolean {
	  return moment(this.startDateString).isSameOrBefore(
	    cycle.qualificationEndDate,
	  );
	}

	reloadStartDateOnOrAfterQualStartDate(cycle: Cycle): boolean {
	  return moment(this.startDateString).isSameOrAfter(
	    cycle.qualificationStartDate,
	  );
	}

	isCycleEntirelyInReloadPeriod(cycle: Cycle): boolean {
	  return (
	    moment(cycle.qualificationStartDate).isAfter(this.startDateString)
			&& moment(cycle.qualificationEndDate).isSameOrBefore(this.endDateString)
	  );
	}

	submitJob() {
	  if (this.totalReloadDays > 45 && !this.largeReloadConfirmed) {
	    this.showLargeReloadConfirmation = true;
	  } else {
	    this.submittingJob = true;
	    this.reloadResource
	      .submitReloadJob(this.buildReloadRequest())
	      .then((response: any) => {
	        this.$emit('success');
	        this.dialog = false;
	      })
	      .catch((error: any) => {
	        if (error.response.status !== 401) {
	          if (error.response.data) {
	            this.reloadErrorMessage = error.response.data;
	          } else {
	            this.reloadErrorMessage = this.GENERIC_RELOAD_ERROR;
	          }
	          this.submittingJob = false;
	        }
	      });
	  }
	}

	buildReloadRequest(): ReloadRequest {
	  return {
	    fiId: parseInt(this.getSelectedFiId(), 10),
	    reloadPoint: this.reloadPoint,
	    startDate: new LocalDateTime(this.startDateString).toDateArray(),
	    endDate: new LocalDateTime(this.endDateString).toDateArray(),
	    reason: this.reloadReason[0],
	    cancelExistingReloads: this.cancelExistingReloads,
	    skipRewardsProcessing: this.skipRewardsProcessing,
	    recompArgumentList: this.recompArgumentList,
	  };
	}
}
